module.exports = __webpack_public_path__ + "static/Structure3D@2x-min-840fd17e74523966c7ee93ba7111554b.png";